import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import deepmerge from 'deepmerge';
import { useDeferredValue, useEffect } from 'react';
import useSWR from 'swr';
import { useValueControl } from '@snack-uikit/utils';
import { ProductContext, useCalculatorContext } from '../../contexts';
import { useAdaptive } from '../../hooks';
import { getValue, parseKeyToDataTest, setValue } from '../../utils';
import { CONTROL } from '../Controls';
import { Control } from '../Controls/Control';
import { ProductPageHeadline } from '../ProductHeadline';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProductPage(_ref) {
  var _config$products$sele, _config$products$sele2, _config$products$sele3, _config$products$sele4;
  var className = _ref.className,
    selectedProduct = _ref.selectedProduct;
  var _useCalculatorContext = useCalculatorContext(),
    calculatorType = _useCalculatorContext.calculatorType,
    config = _useCalculatorContext.config,
    products = _useCalculatorContext.products,
    setProducts = _useCalculatorContext.setProducts,
    fetcherFn = _useCalculatorContext.fetcherFn;
  var _useAdaptive = useAdaptive(),
    isMobile = _useAdaptive.isMobile;
  var baseAccessorKey = "".concat(selectedProduct.id, "[").concat(selectedProduct.idx, "]");
  var accessorKey = {
    data: "".concat(baseAccessorKey, ".data"),
    price: "".concat(baseAccessorKey, ".price"),
    priceList: "".concat(baseAccessorKey, ".priceList")
  };
  var _useValueControl = useValueControl({
      value: getValue(products, accessorKey.data),
      onChange: function onChange(newFormData) {
        setProducts(function (value) {
          setValue(value, accessorKey.data, newFormData);
          return value;
        });
      }
    }),
    _useValueControl2 = _slicedToArray(_useValueControl, 2),
    formData = _useValueControl2[0],
    setFormData = _useValueControl2[1];
  var deferredFormData = useDeferredValue(JSON.stringify(formData));
  var deferredSelectedProductId = useDeferredValue(selectedProduct.id);
  var _useSWR = useSWR({
      productId: deferredSelectedProductId,
      formData: deferredFormData,
      calculatorType: calculatorType
    }, fetcherFn),
    data = _useSWR.data;
  useEffect(function () {
    if (data) {
      setProducts(function (oldValue) {
        (data === null || data === void 0 ? void 0 : data.price) && setValue(oldValue, accessorKey.price, data.price);
        if (data !== null && data !== void 0 && data.values) {
          var oldProductData = getValue(oldValue, accessorKey.data);
          setValue(oldValue, accessorKey.data, deepmerge(oldProductData, data.values));
        }
        (data === null || data === void 0 ? void 0 : data.priceList) && setValue(oldValue, accessorKey.priceList, data.priceList);
        return _objectSpread({}, oldValue);
      });
    }
  }, [data, setProducts, accessorKey.price, accessorKey.priceList, accessorKey.data]);
  var deferredPrice = useDeferredValue(getValue(products, accessorKey.price));
  var deferredPriceList = useDeferredValue(getValue(products, accessorKey.priceList));
  var dataTestAttribute = parseKeyToDataTest('configurator');
  return /*#__PURE__*/_jsx(ProductContext.Provider, {
    value: {
      value: _objectSpread({}, getValue(products, accessorKey.data)),
      onChange: setFormData,
      price: deferredPrice,
      priceList: deferredPriceList
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: className,
      "data-test-id": dataTestAttribute,
      children: [/*#__PURE__*/_jsx(ProductPageHeadline, {
        product: config.products[selectedProduct.id]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.content,
        "data-mobile": isMobile || undefined,
        children: /*#__PURE__*/_jsx(Control, {
          formControl: {
            type: CONTROL.Object,
            ui: (_config$products$sele = (_config$products$sele2 = config.products[selectedProduct.id].formConfig) === null || _config$products$sele2 === void 0 ? void 0 : _config$products$sele2.ui) !== null && _config$products$sele !== void 0 ? _config$products$sele : [],
            controls: (_config$products$sele3 = (_config$products$sele4 = config.products[selectedProduct.id].formConfig) === null || _config$products$sele4 === void 0 ? void 0 : _config$products$sele4.controls) !== null && _config$products$sele3 !== void 0 ? _config$products$sele3 : {}
          }
        })
      })]
    })
  });
}